import { httpClient, httpClientUrlStringBuilder } from '@/network/clientController'

/** Get Mobile Payments status list
@docs Não existe
*/
export const getMobilePaymentsStatusList = (payload) => {
	return httpClient({
		method: 'GET',
		url: 'mobile-payments/status',
		isCancellable: true
	})
}

/** Get Mobile Payments operations list
@docs Não existe
*/
export const getMobilePaymentsList = (payload) => {
	return httpClient({
		method: 'GET',
		url: 'mobile-payments/search',
		params: payload,
		isCancellable: true
	})
}

/** Get Mobile Payment detail
@docs Não existe
*/
export const getMobilePaymentDetail = (payload) => {
	return httpClient({
		method: 'GET',
		url: `mobile-payments/${payload}`,
		isCancellable: true
	})
}

/** Reject Mobile Payment
@docs Não existe
*/
export const rejectMobilePayment = (payload) => {
	return httpClient({
		method: 'POST',
		url: `mobile-payments/refuse/merchant/${payload}`,
		isCancellable: true
	})
}

/** Sends a Mobile Payment operation notification to email
@docs Não há documentação
*/
export const sendMobilePaymentEmailNotification = payload => {
	return httpClient({
		method: 'POST',
		url: `/mobile-payments/${payload.operationId}/notification/email`,
		data: { email: payload.data.email }
	})
}

/** Sends a Mobile Payment operation notification to sms
@docs Não há documentação
*/
export const sendMobilePaymentSmsNotification = payload => {
	return httpClient({
		method: 'POST',
		url: `/mobile-payments/${payload.operationId}/notification/sms`,
		data: { phoneNumber: payload.data.phoneNumber }
	})
}

/** Creates the url to download mobile payment operation receipt pdf
@docs Não há documentação
*/
export const createDownloadMobilePaymentsReceiptPdf = payload => {
	return httpClientUrlStringBuilder({
		method: 'GET',
		url: `mobile-payments/${payload}/receipt`
	})
}

/** Pay pending bai paga request
@docs Não há documentação
*/
export const payPendingBaiPagaRequest = (payload) => {
    return httpClient({
		method: 'POST',
		url: `mobile-payments/pay/merchant/${payload.id}`,
        data: payload,
		operationTypeId: 31109 /* for mocks handling of tokens */
	})
}

/** Validate Mobile Payment Merchant Status for a company client
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_internetmobile-paymentsmerchantvalidate
*/
export const validateMobileMerchantStatus = (payload) => {
	return httpClient({
		method: 'GET',
		url: 'mobile-payments/merchant/validate',
		isCancellable: true
	})
}

/** Create Mobile Payment Merchant
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_internetmobile-paymentsmerchant
*/
export const createMobilePaymentMerchant = (payload) => {
    return httpClient({
		method: 'POST',
		url: 'mobile-payments/merchant',
        data: payload,
		operationTypeId: 31005 /* for mocks handling of tokens */
	})
}

/** Get Merchant detail
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_internetmobile-paymentsmerchant
*/
export const getMerchantDetail = (payload) => {
	return httpClient({
		method: 'GET',
		url: 'mobile-payments/merchant',
		params: payload,
		isCancellable: true
	})
}

/** Get Merchant Name
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_internetmobile-paymentsmerchant%7BmerchantExternalId%7D
*/
export const getMerchantName = (payload) => {
	return httpClient({
		method: 'GET',
		url: `mobile-payments/merchant/${payload.merchantExternalId}`,
		isCancellable: true
	})
}

/** Pay pending bai paga request
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_internetmobile-paymentspaymerchant
*/
export const payToBaiPagaMerchant = (payload) => {
    return httpClient({
		method: 'POST',
		url: 'mobile-payments/pay/merchant',
        data: payload,
		operationTypeId: 753 /* for mocks handling of tokens */
	})
}
